import Captcha from './captcha.js'; //Детектор медиа
import Lang from './lang-message.js';

let Resume = {
  initInputFile: function() {

    let resumeInput = $('[data-resume-input-file]');

    if(resumeInput.val() != '')
      resumeInput.closest('[data-resume-input-file-container]').find('[data-resume-input-file-empty]').addClass('off');
    
    $('[data-resume-input-file-container]').on('change', '[data-resume-input-file]', function(event){
      var container = $(this).closest('[data-resume-input-file-container]'),
          textInput = container.find('[data-resume-input-file-text]'),
          fileInput = $(this),
          errorIcon = container.find('[data-icon-error-file]'),
          emptyInput = container.find('[data-resume-input-file-empty]');

      var filePath = fileInput.val();

      if(filePath.match(/fakepath/)) {
        filePath = filePath.replace(/C:\\fakepath\\/i, '');
      }

      if(filePath.length) {
        textInput.val(filePath).removeClass('error');
        emptyInput.addClass('off');
        errorIcon.removeClass('off');
      } else {
        textInput.val(filePath);
        emptyInput.removeClass('off');
        errorIcon.addClass('off');
      }
    });

    $('[data-resume-input-file-text]').on('click',function(){
      if (!($('html').hasClass('bx-ie9')))
        $(this).closest('[data-resume-input-file-container]').find('[data-resume-input-file]').click();
    });

    resumeInput.on('change', function(){
      $(this).removeClass('ignore').valid();

      Resume.setActiveBtnSubmit();
      Resume.setValidFile();
    });
  },
  initValidateForm: function(form) {

    $.validator.setDefaults({
      debug: true,
      success: 'valid',
      ignore: '.ignore, *:not([name]), :hidden:not(input[type="file"])'
    });

    // Размер файла
    $.validator.addMethod("fileSize", function(value, element, param) {
      var result = true;

      if (!($('html').hasClass('bx-ie9'))) {
        if ($(element).length && element.files[0]) {
          if (element.files[0].size > param) {
            var maxSize = Math.round(parseInt($(element).attr('filesize'))/1024/1024);
            $.validator.messages["fileSize"] = Lang.message.file_max_size_field + maxSize + "Mb";
            result = false;
          }
        }
      }
      return result;
    }, Lang.message.incorrect_file_field);

    // Тип файла
    $.validator.addMethod("fileType", function(value, element, param) {
      var result = true;

      if (!($('html').hasClass('bx-ie9'))) {

        if ($(element).length && element.files[0]) {

          var nameFile = element.files[0].name,
              arrNameFile = nameFile.split('.'),
              typeFile = arrNameFile[arrNameFile.length-1];

          if (param.indexOf(typeFile) >= 0) {
            $.validator.messages["fileType"] = "";
            result = true;
          } else {
            $.validator.messages["fileType"] = Lang.message.incorrect_format_file_field;
            result = false;
          }
        }
      }

      return result;
    }, "Некорректный файл");

    form.validate({
      rules: {
        RESUME_AGREEMENT: {
          required: true
        }        
      },
      messages: {
        RESUME_AGREEMENT: {
          required: Lang.message.agree_agreement_field
        }
      }
    });
  },
  submitForm: function(form) {
    form.on('submit', function(e){
        e.preventDefault();

        if($(this).valid()){
          var formData = new FormData(this);
          formData.append('file', $('[data-resume-input-file]')[0].files[0]);
          $.ajax({
              url: $(this).attr('action'),
              method: $(this).attr('method'),
              data: formData,
              dataType: 'json',
              processData: false,
              contentType: false,
              success: function(response){
                let popupForm = $('[data-form-resume-wrap]').find('[data-form-popup]');

                $('[data-img-captcha]').empty().append('<img src="' + response.captcha_img + '" alt="" />');
                $('[data-hidden-input-captcha]').val(response.captcha_code);

                if (response.success) {
                    popupForm.find('[data-content-form-popup]').html('<div class="item item_big">Спасибо!</div><div class="item">Ваше резюме отправлено</div>');
                    popupForm.addClass('open');

                    $('body').addClass('open-form-popup');

                    Resume.clearForm(form);
                } else {
                    popupForm.find('[data-content-form-popup]').html('<div class="item item_big">Ошибка!</div><div class="item">' + response.description.message + '</div>');

                    popupForm.addClass('open');
                }

                
              }
          });
        }
    });
  },
  clearForm: function(form){
    form[0].reset();
    form.find('[data-submit-resume]').addClass('btn_disabled').attr('disabled');
    form.find('[data-resume-input-file-empty]').removeClass('off');
    form.find('[data-stylized-placeholder]').show();
  },
  setActiveBtnSubmit: function() {
    var _valid = true;

    $('[data-valid-input]').each(function(index) {
      if(!$(this).valid()) {
        _valid = false;
      }
    });

    if(_valid){
      $('[data-submit-resume]')
        .removeClass('btn_disabled')
        .removeAttr('disabled');
    }else{
      $('[data-submit-resume]')
        .addClass('btn_disabled')
        .attr('disabled');
    }
  },
  setValidFile: function(){
    if($('[data-resume-input-file]').valid()){
      $('[data-resume-input-file-container]').removeClass('error');
    }else{
      $('[data-resume-input-file-container]').addClass('error');
    }
  }
}

$(document).ready(function ($) {

  let formResume = $('[data-form-resume]');
  if(formResume.length) {

    if (typeof RESUME_VACANCY != 'undefined' && RESUME_VACANCY.length) {
        $('form.resume-form input[name=RESUME_VACANCY]').val(RESUME_VACANCY);
    }

    Captcha.initCaptcha();

    formResume.find('[data-mask-phone]').mask('+7 (000) 000-00-00');
  
    Resume.initInputFile();

    Resume.initValidateForm(formResume);
    Resume.submitForm(formResume);

    $('[data-valid-input]').on('input', function(){
      Resume.setActiveBtnSubmit();
      Resume.setValidFile();
    });

    $('[data-agreement-input]').on('change', function(){
      Resume.setActiveBtnSubmit();
    });
  }
});



// WEBPACK FOOTER //
// ./components/resume.js